import { type IconProps } from './icon';

const APPLE_SPINNER_SIZE = 32;

type SpinnerProps = Omit<IconProps, 'size'>;

export const AppleSpinner = ({ color = 'currentColor', ...props }: SpinnerProps) => {
	const maskStyles: React.CSSProperties = {
		maskType: 'alpha',
	};

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={APPLE_SPINNER_SIZE}
			height={APPLE_SPINNER_SIZE}
			viewBox="0 0 32 32"
			fill="none"
			{...props}>
			<g opacity="0.1">
				<mask id="mask0_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="4" y="8" width="8" height="5">
					<path
						d="M4.90394 10.1338C4.46339 9.87944 4.31762 9.30714 4.57128 8.86778L4.5936 8.82913C4.85043 8.38429 5.41531 8.2296 5.85633 8.48422L10.5593 11.1995C10.9999 11.4538 11.1456 12.0261 10.892 12.4655L10.8697 12.5041C10.6128 12.949 10.0479 13.1037 9.60693 12.8491L4.90394 10.1338Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask0_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.17">
				<mask id="mask1_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="8" y="3" width="6" height="8">
					<path
						d="M8.8825 5.39743C8.62814 4.95688 8.78804 4.38837 9.2274 4.13471L9.26606 4.11239C9.7109 3.85556 10.2774 4.00403 10.5321 4.44504L13.2473 9.14803C13.5017 9.58859 13.3418 10.1571 12.9024 10.4107L12.8638 10.4331C12.4189 10.6899 11.8524 10.5414 11.5978 10.1004L8.8825 5.39743Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask1_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-7.83983 42.6667H45.4935V-10.6667H-7.83983V42.6667Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.2">
				<mask id="mask2_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="14" y="2" width="3" height="8">
					<path
						d="M15.8045 2.66666H15.8491C16.3628 2.66666 16.7792 3.07851 16.7792 3.58775V9.01828C16.7792 9.52699 16.3565 9.93939 15.8491 9.93939H15.8045C15.2908 9.93939 14.8744 9.52754 14.8744 9.01828V3.58775C14.8744 3.07904 15.2972 2.66666 15.8045 2.66666Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask2_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.3">
				<mask id="mask3_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="18" y="3" width="5" height="8">
					<path
						d="M21.1216 4.44503C21.3759 4.00448 21.9482 3.85871 22.3876 4.11237L22.4262 4.13469C22.8711 4.39152 23.0258 4.9564 22.7711 5.39741L20.0559 10.1004C19.8015 10.5409 19.2292 10.6867 18.7899 10.4331L18.7512 10.4107C18.3064 10.1539 18.1517 9.58903 18.4063 9.14802L21.1216 4.44503Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask3_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.4">
				<path
					d="M25.7973 8.96907C26.2379 8.71472 26.8064 8.87462 27.0601 9.31398L27.0824 9.35264C27.3392 9.79748 27.1907 10.364 26.7497 10.6186L22.0467 13.3339C21.6062 13.5883 21.0377 13.4284 20.784 12.989L20.7617 12.9504C20.5049 12.5055 20.6533 11.939 21.0944 11.6843L25.7973 8.96907Z"
					fill={color}
				/>
			</g>
			<g opacity="0.4">
				<mask id="mask4_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="21" y="14" width="8" height="3">
					<path
						d="M22.6354 16.4675C22.1267 16.4675 21.7143 16.0448 21.7143 15.5374V15.4928C21.7143 14.9791 22.1261 14.5627 22.6354 14.5627H28.0659C28.5746 14.5627 28.987 14.9855 28.987 15.4928V15.5374C28.987 16.0511 28.5752 16.4675 28.0659 16.4675H22.6354Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask4_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6667H42.4935V-10.6667H-10.8398V42.6667Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.5">
				<mask id="mask5_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="20" y="18" width="8" height="5">
					<path
						d="M21.0944 19.8308C20.6538 19.5764 20.5081 19.0041 20.7617 18.5648L20.7841 18.5261C21.0409 18.0813 21.6058 17.9266 22.0468 18.1812L26.7498 20.8965C27.1903 21.1508 27.3361 21.7231 27.0824 22.1625L27.0601 22.2011C26.8033 22.646 26.2384 22.8007 25.7974 22.546L21.0944 19.8308Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask5_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.6">
				<mask id="mask6_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="18" y="20" width="5" height="8">
					<path
						d="M18.4063 22.3671C18.1519 21.9265 18.3118 21.358 18.7512 21.1044L18.7899 21.0821C19.2347 20.8252 19.8013 20.9737 20.0559 21.4147L22.7711 26.1177C23.0255 26.5582 22.8656 27.1268 22.4262 27.3804L22.3876 27.4027C21.9427 27.6596 21.3762 27.5111 21.1216 27.0701L18.4063 22.3671Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask6_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.7">
				<mask id="mask7_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="14" y="22" width="3" height="8">
					<path
						d="M15.8491 29.3333H15.8045C15.2908 29.3333 14.8744 28.9215 14.8744 28.4122V22.9817C14.8744 22.473 15.2972 22.0606 15.8045 22.0606H15.8491C16.3628 22.0606 16.7792 22.4725 16.7792 22.9817V28.4122C16.7792 28.921 16.3565 29.3333 15.8491 29.3333Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask7_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6667H42.4935V-10.6667H-10.8398V42.6667Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.8">
				<mask id="mask8_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="8" y="20" width="6" height="8">
					<path
						d="M11.5978 21.4147C11.8521 20.9742 12.4244 20.8284 12.8638 21.0821L12.9024 21.1044C13.3473 21.3612 13.5019 21.9261 13.2473 22.3671L10.5321 27.0701C10.2777 27.5106 9.70541 27.6564 9.26605 27.4028L9.2274 27.3804C8.78256 27.1236 8.62787 26.5587 8.88249 26.1177L11.5978 21.4147Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask8_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<g opacity="0.9">
				<mask id="mask9_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="4" y="18" width="8" height="6">
					<path
						d="M9.6069 18.666C10.0474 18.4117 10.616 18.5716 10.8696 19.0109L10.8919 19.0496C11.1488 19.4945 11.0003 20.061 10.5593 20.3156L5.85629 23.0309C5.41574 23.2852 4.84724 23.1253 4.59357 22.686L4.57125 22.6473C4.31442 22.2025 4.46289 21.6359 4.90391 21.3813L9.6069 18.666Z"
						fill={color}
					/>
				</mask>
				<g mask="url(#mask9_4_7067)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
						fill={color}
					/>
				</g>
			</g>
			<mask id="mask10_4_7067" style={maskStyles} maskUnits="userSpaceOnUse" x="2" y="14" width="8" height="3">
				<path
					d="M3.58777 16.4675C3.07906 16.4675 2.66667 16.0448 2.66667 15.5374V15.4928C2.66667 14.9791 3.07852 14.5627 3.58777 14.5627H9.0183C9.527 14.5627 9.9394 14.9855 9.9394 15.4928V15.5374C9.9394 16.0511 9.52755 16.4675 9.0183 16.4675H3.58777Z"
					fill={color}
				/>
			</mask>
			<g mask="url(#mask10_4_7067)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M-10.8398 42.6666H42.4935V-10.6667H-10.8398V42.6666Z"
					fill={color}
				/>
			</g>
		</svg>
	);
};
